import { intersection, groupBy, pick, merge } from 'lodash';
import {fromPairs, flatten, map, identity, isNil, uniq, prop} from 'ramda';

const temp1 = {
  "invoice": {
    "invoice_project_id": "71",
    "invoice_language": "de",
    "invoice_user_id": "122",
    "notes": null,
    "invoice_ref": "2019-0004",
    "last_modified": "2019-07-10 15:50:22",
    "external_table2": null,
    "payment_method_id": "1",
    "external_ref": null,
    "created": "2019-07-10 15:50:21",
    "amount": "144.00",
    "invoice_ref_key": "2019-#nr#",
    "contact_id": "9018",
    "exchange_rate_creation": null,
    "tax_type_id_deduction": null,
    "cost_group_id": null,
    "external_id": "4092",
    "vat_rate1": null,
    "vat_rate3": null,
    "trailing_text": "",
    "leading_text": "",
    "performance_country": "Germany",
    "exported_date": null,
    "subject": "2019-07-10 / DJ Checkbox Auto, DJ Jabba the Hut, DJ Obi Wan Kenobi, DJ R2D2 / Tenth Doc / Admiralspalast / Berlin / Germany",
    "end_of_month_flag": null,
    "invoice_no": "4",
    "net_amount": "144.00",
    "paid_flag": null,
    "gross_amount": "144.00",
    "payment_date": null,
    "tax_deduction_amount": null,
    "invoice_address": "Christof Ellinghaus\nn/a\n10115 Berlin\nGermany",
    "paypal_email": null,
    "external_id2": null,
    "royalty_date1": null,
    "money_account_id": "0",
    "external_table": "calendar_dates",
    "vat_handling": "1",
    "vat1_amount": "0.00",
    "due_days": "13",
    "currency_id": "2",
    "vat2_amount": "0.00",
    "payments": {
      "totalPaymentByExRate": null,
      "totalPayment": null
    },
    "lock_flag": null,
    "sys_currency_iso": "EUR",
    "country_id": null,
    "currency_iso": "EUR",
    "invoice_id": "2272",
    "invoice_date": "2019-07-10",
    "vat_rate2": null,
    "performance_date": "2019-07-10",
    "cost_flag": null,
    "exchange_rate": "1",
    "discount_days": "0",
    "cancelled_flag": null,
    "royalty_date2": null,
    "discount_percent": "0.00",
    "accounting_more_flag": "1"
  },
  "countPayments": "0"
};

const temp2 = {
  "invoice": {
    "sys_currency_iso": "EUR",
    "lock_flag": null,
    "payments": {
      "totalPayment": null,
      "totalPaymentByExRate": null
    },
    "currency_id": "24",
    "vat2_amount": "0.00",
    "due_days": null,
    "vat1_amount": "0.00",
    "vat_handling": "1",
    "external_table": "accounts",
    "money_account_id": null,
    "royalty_date1": null,
    "external_id2": "528",
    "paypal_email": null,
    "invoice_address": "lifo_cf1\n \n3333 \nCanada",
    "accounting_more_flag": "1",
    "discount_percent": null,
    "royalty_date2": null,
    "cancelled_flag": null,
    "discount_days": null,
    "exchange_rate": "4.2735",
    "cost_flag": null,
    "performance_date": "2019-07-11",
    "vat_rate2": "20.00",
    "invoice_date": "2019-07-11",
    "invoice_id": "2273",
    "country_id": null,
    "currency_iso": "BRL",
    "contact_id": "1",
    "exchange_rate_creation": null,
    "amount": "0.00",
    "invoice_ref_key": "2019 - #nr4#",
    "external_ref": null,
    "created": "2019-07-11 09:47:29",
    "payment_method_id": "1",
    "external_table2": "order",
    "invoice_ref": "2019 - 0021",
    "last_modified": "2019-07-11 09:47:29",
    "notes": null,
    "invoice_user_id": null,
    "invoice_language": null,
    "invoice_project_id": "89",
    "tax_deduction_amount": null,
    "payment_date": null,
    "gross_amount": "0.00",
    "paid_flag": null,
    "net_amount": "0.00",
    "invoice_no": "21",
    "end_of_month_flag": null,
    "subject": "Invoice Order #528",
    "exported_date": null,
    "performance_country": "Bangladesh",
    "leading_text": null,
    "trailing_text": null,
    "vat_rate1": "10.00",
    "vat_rate3": null,
    "external_id": null,
    "cost_group_id": null,
    "tax_type_id_deduction": null
  },
  "countPayments": "0"
};

// Map changes between two objects
export const mapChanges = (obj1, obj2) => {
  return intersection(Object.keys(obj1), Object.keys(obj2)).map(key => {
    const oldValue = obj1[key];
    console.log("Log: mapChanges -> oldValue", oldValue)
    const newValue = obj2[key];
    console.log("Log: mapChanges -> newValue", newValue)
    if (oldValue && !newValue) {
      return {
        key, change: 'DELETED',
        newValue,
        oldValue,
      }
    } else if (!oldValue && newValue) {
      return {
        key, change: 'CREATED',
        newValue,
        oldValue,
      }
    } else if (!oldValue && !newValue) {
      return {
        key, change: 'NOT_CHANGED',
        newValue,
        oldValue,
      }
    } else if (newValue !== oldValue) {
      return {
        key, change: 'UPDATED',
        newValue,
        oldValue,
      }
    }
  })
}



// Map common values between two objects
export const mapCommonValues = (objs) => {
  return fromPairs(uniq(
    flatten(objs.map(obj => Object.keys(obj)))
  )
  .map(key => {
    // const oldValue = obj1[key];
    // const newValue = obj2[key];

    const values = map(prop(key)) (objs);

    // console.log({key, values});
    const allEqual = values.every(e => e == values[0]);

    if (allEqual) {
      return {
        key,
        common: values[0]
      };
    }
  })
  .filter(identity)
  .filter(e => !isNil(e.common))
  .map(e => [e.key, e.common]));
};



// console.log(mapCommonValues([temp1.invoice, temp2.invoice]));